import ThumbnailCard from "@components/Blocks/Card/Thumbnail/ThumbnailCard";
import VideoPlayerSticky from "@elements/Player/VideoPlayerSticky";
import { LatestVideoResponse } from "@hooks/transformer/useBrightcoveResponse";
import { ReactElement, RefObject } from "react";
import { twMerge } from "tailwind-merge";

type KakiMakanDesktopVideoProps = {
  containerRef: RefObject<HTMLDivElement>;
  paginated: LatestVideoResponse[];
  handleOnEndedVideo: () => void;
  handleOnClickThumbnail: (props: LatestVideoResponse) => void;
  playing?: LatestVideoResponse;
  varinat?: "short_form_video";
};

/**
 * KakiMakanDesktopVideo
 * Description: [Renders desktop version for kaki makan videos]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function KakiMakanDesktopVideo({
  containerRef,
  paginated,
  handleOnEndedVideo,
  handleOnClickThumbnail,
  playing,
  varinat,
}: KakiMakanDesktopVideoProps): ReactElement {
  const isShortFormVideo = varinat === "short_form_video";
  const showDescription = !isShortFormVideo;
  const gridStyle = isShortFormVideo && "md:grid-cols-3";

  return (
    <>
      <div className="flex flex-row gap-12 items-start">
        <div className="min-w-[300px]">
          {playing?.id && (
            <VideoPlayerSticky
              playing={playing}
              forwadedRef={containerRef}
              onEnded={handleOnEndedVideo}
              nextPlaylist={handleOnEndedVideo}
              showDescription={showDescription}
              variant="kaki_makan_page"
            />
          )}
        </div>
        <div className="w-full max-w-[815px]">
          <div className={twMerge("grid md:grid-cols-4 gap-4", gridStyle)}>
            {paginated.map((video, index) => (
              <ThumbnailCard<LatestVideoResponse>
                key={index}
                testId={`video-kaki-makan-${index}`}
                handleOnClickThumbnail={handleOnClickThumbnail}
                variant="kaki_makan_page"
                {...video}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
